import React, { useEffect, useState } from 'react';
import { questionsList } from './QuestionsList';
import axios from 'axios';
import { Button, Grid } from '@mui/joy';
import { Backdrop, CircularProgress } from '@mui/material';
import { endpoint } from '../../resource/Constant';
import { toast } from 'react-toastify';

export default function Questions() {
  const [questionCount, setQuestionCount] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [finish, setFinish] = useState(false);
  const [result, setResult] = useState();
  const [loader, setLoader] = useState(false);
  const getResult = () => {
    setLoader(true);
    const prompt = `${answers?.map((ans) => ans)}`;
    const param = { prompt: prompt, weeks: 4 };
    axios
      .post(`${endpoint}/api/aichatbot/getaischedule`, null, {
        params: param,
        headers: { Authorization: `Bearer ${localStorage.getItem('adminChatauthToken')}` }
      })
      .then((res) => {
        setResult([]);
        setResult(res?.data);
        localStorage.removeItem('aicourseresults');
        localStorage.setItem('aicourseresults', JSON.stringify(res?.data));
        setQuestionCount(0);
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        toast.error(`Network Error,Please Try Again Later.`, {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'error1'
        });
      });
  };
  useEffect(() => {
    if (questionCount >= questionsList.length) {
      getResult();
      setFinish(true);
    }
    if (questionCount == 0) {
      setAnswers([]);
    }
  }, [questionCount]);
  useEffect(() => {
    if (localStorage.getItem('aicourseresults')) {
      setResult([]);
      setResult(JSON.parse(localStorage.getItem('aicourseresults')));
      setQuestionCount(0);
      setAnswers([]);
      setFinish(true);
    }
  });
  return (
    <>
      <Grid container sx={{ width: '100%' }} style={{ minHeight: '100vh' }}>
        {!finish ? (
          <Grid container sx={{ justifyContent: 'center' }} spacing={2}>
            <Grid item xs={12} md={10}>
              <h3 style={{ fontSize: '30px', fontWeight: '700', color: 'white' }}>
                {questionsList[questionCount]?.question} {questionCount}/15
              </h3>
            </Grid>
            <Grid item xs={12} md={10}>
              {questionsList[questionCount]?.options.map((option) => (
                <Grid key={option.id} style={{ margin: '40px' }}>
                  <button
                    className="li-course-option"
                    onClick={() => {
                      setQuestionCount((prev) => prev + 1);
                      setAnswers((prev) => [...prev, option.result]);
                    }}
                  >
                    {option.description}
                  </button>
                </Grid>
              ))}
            </Grid>
          </Grid>
        ) : (
          <Grid container sx={{ justifyContent: 'center' }} spacing={2}>
            <Grid item xs={12}>
              <h3 style={{ fontSize: '30px', fontWeight: '700', color: 'white' }}>✨ Here's Your Personalized Plan to Get AI-Ready! 🚀</h3>
            </Grid>
            {!loader &&
              result?.map((res) => {
                return (
                  <Grid item xs={12} md={5} className="week-div" key={res?.id}>
                    <h3 style={{ color: `#007bff`, fontWeight: 700 }}>WEEK {res?.id}</h3>
                    {res.result.map((result) => (
                      <Grid pb={'10px'} className="topic-resource-pair">
                        <h4 style={{ color: 'white', fontWeight: 600 }}>TOPIC: {result.topic}</h4>
                        <h4 style={{ color: 'white', fontWeight: 600 }}>RESOURCE: {result.resource}</h4>
                      </Grid>
                    ))}
                  </Grid>
                );
              })}

            <Grid item xs={12}>
              <Button
                className="li-course-finder"
                sx={{ fontWeight: 700, fontSize: '17px', marginTop: '20px' }}
                onClick={() => {
                  setAnswers([]);
                  setQuestionCount(0);
                  setResult([]);
                  setFinish(false);
                  localStorage.removeItem('aicourseresults');
                }}
              >
                New Study-Plan
              </Button>
            </Grid>
          </Grid>
        )}
      </Grid>
      <Backdrop open={loader}>
        <svg width={0} height={0}>
          <defs>
            <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#e01cd5" />
              <stop offset="100%" stopColor="#1CB5E0" />
            </linearGradient>
          </defs>
        </svg>
        <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} size={70} thickness={3} />
      </Backdrop>
    </>
  );
}
